/* Vanshitaaz wishlist drawer — full-width takeover, same collection-2026
   grid as the collection page. Cards are fetched per saved item via
   sections/wishlist-item-card.liquid and diffed against localStorage on
   every open + every wishlist change while open (deletes, "Move to Bag").
   Requires assets/wishlist.js (storage) and collection-2026.js (the shared
   size-select sheet — rendered once by snippets/wishlist-drawer.liquid). */
(function () {
  'use strict';

  class WishlistDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', function (evt) { if (evt.code === 'Escape') this.close(); }.bind(this));
      this.addEventListener('click', this.handleClick.bind(this));
      this.setupIcon();
      window.addEventListener(window.VZWishlist ? window.VZWishlist.EVENT : 'vz:wishlist:change', function () {
        if (this.classList.contains('active')) this.render();
      }.bind(this));
    }

    setupIcon() {
      var icon = document.getElementById('wishlist-icon-bubble');
      if (!icon) return;
      icon.setAttribute('role', 'button');
      icon.addEventListener('click', function (evt) {
        evt.preventDefault();
        this.open();
      }.bind(this));
    }

    handleClick(evt) {
      if (evt.target.closest('[data-wishlist-close]')) {
        evt.preventDefault();
        this.close();
        return;
      }
      var delBtn = evt.target.closest('[data-c26-wish-remove]');
      if (delBtn && window.VZWishlist) {
        window.VZWishlist.remove(delBtn.getAttribute('data-product-id'));
      }
    }

    open() {
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
      this.render();
    }

    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }

    render() {
      if (!window.VZWishlist) return;
      var items = window.VZWishlist.getAll();
      var grid = this.querySelector('[data-wishlist-grid]');
      var emptyEl = this.querySelector('[data-wishlist-empty]');
      var footEl = this.querySelector('[data-wishlist-foot]');
      var countEl = this.querySelector('[data-wishlist-count]');
      if (!grid) return;

      if (countEl) countEl.textContent = '(' + items.length + ')';

      var ids = items.map(function (item) { return String(item.id); });
      grid.querySelectorAll('[data-c26-card]').forEach(function (card) {
        if (ids.indexOf(card.getAttribute('data-product-id')) === -1) {
          var li = card.closest('.grid__item');
          if (li) li.remove();
        }
      });

      if (!items.length) {
        grid.hidden = true;
        if (footEl) footEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      grid.hidden = false;
      if (footEl) footEl.hidden = false;

      var existingIds = Array.prototype.map.call(
        grid.querySelectorAll('[data-c26-card]'),
        function (card) { return card.getAttribute('data-product-id'); }
      );
      items
        .filter(function (item) { return existingIds.indexOf(String(item.id)) === -1; })
        .forEach(function (item) {
          // show something from the cached data immediately (image, title,
          // price — all saved in localStorage at add-time) instead of a
          // blank grid while the real card's network fetch is in flight;
          // the real fetch below then swaps this skeleton out in place.
          var skeleton = this.renderSkeleton(item);
          grid.appendChild(skeleton);
          this.fetchCard(item, grid, skeleton);
        }, this);

      this.updateTotals(items);
    }

    renderSkeleton(item) {
      var li = document.createElement('li');
      li.className = 'grid__item';

      var card = document.createElement('div');
      card.className = 'c26-card';
      card.setAttribute('data-c26-card', '');
      card.setAttribute('data-skeleton', '1');
      card.setAttribute('data-product-id', item.id);
      li.appendChild(card);

      var media = document.createElement('a');
      media.className = 'c26-card__media';
      media.href = item.url || '#';
      if (item.img) {
        var img = document.createElement('img');
        img.src = item.img;
        img.alt = '';
        img.loading = 'eager';
        media.appendChild(img);
      }
      card.appendChild(media);

      var strip = document.createElement('div');
      strip.className = 'c26-card__strip';
      var moveBtn = document.createElement('button');
      moveBtn.type = 'button';
      moveBtn.className = 'c26-card__add';
      // no data-c26-open yet — the size-select data only exists once the
      // real card lands, which is normally near-instant (same-origin fetch)
      moveBtn.textContent = 'Move to Bag';
      strip.appendChild(moveBtn);
      var delBtn = document.createElement('button');
      delBtn.type = 'button';
      delBtn.className = 'c26-card__del';
      delBtn.setAttribute('data-c26-wish-remove', '');
      delBtn.setAttribute('data-product-id', item.id);
      delBtn.setAttribute('aria-label', 'Remove from wishlist');
      delBtn.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M4 6h12M8 6V4.5A1.5 1.5 0 019.5 3h1A1.5 1.5 0 0112 4.5V6m-6.5 0 .6 9.4a1.5 1.5 0 001.5 1.4h3.8a1.5 1.5 0 001.5-1.4L14.5 6"/></svg>';
      strip.appendChild(delBtn);
      card.appendChild(strip);

      var body = document.createElement('div');
      body.className = 'c26-card__body';
      if (item.fabric) {
        var fabric = document.createElement('span');
        fabric.className = 'c26-card__fabric';
        fabric.textContent = item.fabric;
        body.appendChild(fabric);
      }
      var title = document.createElement('a');
      title.className = 'c26-card__title';
      title.href = item.url || '#';
      title.textContent = item.title || '';
      body.appendChild(title);
      var price = document.createElement('span');
      price.className = 'c26-card__price';
      var moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      price.innerHTML = window.VZWishlist.formatMoney(item.priceCents || 0, moneyFormat);
      body.appendChild(price);
      card.appendChild(body);

      return li;
    }

    fetchCard(item, grid, skeleton) {
      if (!item.url) return;
      var sep = item.url.indexOf('?') === -1 ? '?' : '&';
      fetch(item.url + sep + 'section_id=wishlist-item-card')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var li = doc.querySelector('.grid__item');
          if (!li) return;
          if (skeleton && skeleton.isConnected) skeleton.replaceWith(li);
          else grid.appendChild(li);
        })
        .catch(function () {
          // saved item unavailable (deleted product, etc.) — drop the
          // skeleton rather than leaving a dead, never-loading card
          if (skeleton && skeleton.isConnected) skeleton.remove();
        });
    }

    updateTotals(items) {
      var moneyFormat = this.dataset.moneyFormat || '${{amount}}';

      // per-item: current selling price vs. its own compare_at_price (if any)
      var current = 0, original = 0;
      items.forEach(function (item) {
        var price = item.priceCents || 0;
        var compare = item.compareCents > price ? item.compareCents : price;
        current += price;
        original += compare;
      });

      // store-wide: the same spend-threshold discount the cart drawer applies
      // (settings.discount_threshold_1/2/3 + discount_savings_1/2/3) — highest
      // threshold met wins, checked against the pre-discount (original) total
      var thresholds = (this.dataset.discountThresholds || '0,0,0').split(',').map(Number);
      var savingsTable = (this.dataset.discountSavings || '0,0,0').split(',').map(Number);
      var tieredSavings = 0;
      if (thresholds[2] > 0 && original >= thresholds[2]) tieredSavings = savingsTable[2];
      else if (thresholds[1] > 0 && original >= thresholds[1]) tieredSavings = savingsTable[1];
      else if (thresholds[0] > 0 && original >= thresholds[0]) tieredSavings = savingsTable[0];

      var finalTotal = Math.max(0, current - tieredSavings);
      var totalSavings = original - finalTotal;

      var totalEl = this.querySelector('[data-wishlist-total]');
      if (totalEl) {
        var html = '';
        if (totalSavings > 0) {
          html += '<span class="wishlist-totals__orig">' + window.VZWishlist.formatMoney(original, moneyFormat) + '</span>';
        }
        html += window.VZWishlist.formatMoney(finalTotal, moneyFormat);
        totalEl.innerHTML = html;
      }

      var savingsEl = this.querySelector('[data-wishlist-savings]');
      if (savingsEl) {
        if (totalSavings > 0) {
          savingsEl.hidden = false;
          // shop.money_format is often HTML (e.g. <span class="money">...</span>)
          // — same as the total above, this needs innerHTML, not textContent,
          // or the markup shows up as literal on-page text.
          savingsEl.innerHTML = window.VZWishlist.formatMoney(totalSavings, moneyFormat) + ' saved';
        } else {
          savingsEl.hidden = true;
        }
      }
    }
  }

  customElements.define('wishlist-drawer', WishlistDrawer);
})();
